import { Component } from '@angular/core';

/**
 * Page/view component for admin tools.
 */
@Component({
  selector: 'sg2-admin-tools-view',
  templateUrl: './admin-tools-view.component.html',
  styleUrls: ['./admin-tools-view.component.less']
})
export class AdminToolsViewComponent {

  constructor() { }
}
